import React from 'react';
import { IconProps } from '.';

const SvgPlus = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M11.25 11.25V3h1.5v8.25H21v1.5h-8.25V21h-1.5v-8.25H3v-1.5h8.25Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgPlus;
